import React, { useEffect, useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Eye, EyeOff } from "lucide-react";
import { login } from "../../redux/actions/adminActions";

const checkValidation = (name, value) => {
  switch (name) {
    case "email":
      if (!value) return "Email is required";
      if (!value.match(/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/)) return "Enter a valid email address";
      return "";
    case "password":
      if (!value || value.trim() === "") return "Password is required";
      return "";
    default:
      return "";
  }
};

const Login = () => {
  const [fields, setFields] = useState({ email: "", password: "" });
  const [validation, setValidation] = useState({ email: "", password: "" });
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const dispatch = useDispatch();
  const adminLogin = useSelector((state) => state.adminLogin);
  const navigate = useNavigate();

  const isAuthed = !!localStorage.getItem("accessToken");

  useEffect(() => {
    if (adminLogin?.loading !== undefined) setLoading(adminLogin.loading);
  }, [adminLogin]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setValidation({ ...validation, [name]: checkValidation(name, value) });
    setFields({ ...fields, [name]: value });
  };

  const handleLogin = (e) => {
    e.preventDefault();
    const errors = {};
    Object.keys(fields).forEach((name) => {
      const err = checkValidation(name, fields[name]);
      if (err) errors[name] = err;
    });
    if (Object.keys(errors).length > 0) {
      setValidation(errors);
      return;
    }
    dispatch(login(fields.email, fields.password, navigate));
  };

  if (isAuthed) return null;

  return (
    <form onSubmit={handleLogin}>
      <p className="auth__pretitle">Roots Funding</p>
      <h1 className="auth__title">Sign in</h1>
      <p className="auth__sub">Use your Roots Funding credentials</p>

      <div className="auth__field">
        <label className="auth__label" htmlFor="login-email">Email</label>
        <div className="auth__input-wrap">
          <input
            id="login-email"
            type="email"
            name="email"
            className="auth__input"
            placeholder="you@rootsfunding.com"
            value={fields.email}
            onChange={handleChange}
            autoComplete="email"
          />
        </div>
        {validation.email && <span className="auth__error">{validation.email}</span>}
      </div>

      <div className="auth__field">
        <label className="auth__label" htmlFor="login-password">Password</label>
        <div className="auth__input-wrap">
          <input
            id="login-password"
            type={showPassword ? "text" : "password"}
            name="password"
            className="auth__input auth__input--with-icon"
            placeholder="Password"
            value={fields.password}
            onChange={handleChange}
            autoComplete="current-password"
          />
          <button
            type="button"
            className="auth__eye"
            aria-label={showPassword ? "Hide password" : "Show password"}
            onClick={() => setShowPassword((v) => !v)}
          >
            {showPassword ? <Eye /> : <EyeOff />}
          </button>
        </div>
        {validation.password && <span className="auth__error">{validation.password}</span>}
      </div>

      <button type="submit" className="auth__submit" disabled={loading}>
        {loading ? "Signing in…" : "Sign in"}
      </button>

      <Link to="/forgot-password" className="auth__link">Forgot password?</Link>
    </form>
  );
};

export default Login;
